module.exports = __webpack_public_path__ + "img/sinpe.a0e456d.svg";